function localidadErrors() {
	const errors = [];
	if (!this.$v.form.localidad.$dirty) return errors;
	!this.$v.form.localidad.requiredIf && errors.push('Este campo es obligatorio si no se usa latitud y longitud');
	return errors
}

function cpErrors() {
	const errors = []
	if (!this.$v.form.cp.$dirty) return errors;
	this.form.cp && (!this.$v.form.cp.min || !this.$v.form.cp.max) && errors.push('Código postal no válido')
	!this.$v.form.cp.requiredIf && errors.push('Este campo es obligatorio si no se usa latitud y longitud');
	return errors
}

function direccionErrors() {
	const errors = []
	if (!this.$v.form.direccion.$dirty) return errors;
	!this.$v.form.cp.requiredIf && errors.push('Este campo es obligatorio si no se usa latitud y longitud');
	return errors
}

function latitudErrors() {
	const errors = []
	if (!this.$v.form.lat.$dirty) return errors;
	!this.$v.form.lat.requiredIf && errors.push('Este campo es obligatorio si no se usa localidad, código postal y dirección');
	!this.$v.form.lat.validLatSpain && errors.push('Latitud no válida dentro de territorio español');
	return errors
}

function longitudErrors() {
	const errors = []
	if (!this.$v.form.lng.$dirty) return errors;
	!this.$v.form.lng.requiredIf && errors.push('Este campo es obligatorio si no se usa localidad, código postal y dirección');
	!this.$v.form.lng.validLongSpain && errors.push('Longitud no válida dentro de territorio español');
	return errors
}

export {
	localidadErrors,
	cpErrors,
	direccionErrors,
	latitudErrors,
	longitudErrors
};
